import { CBadge } from "@coreui/react";
import React, { useEffect, useState } from "react";

import { apiCallSPGet } from "src/_apiConfig/apiCall";
import Auth from "src/auth";
import CommonList from "src/views/common/CommonList";
import {
  CommonSearchExtra,
  SCAddButton,
  SCInput,
  updateSearchStatus,
} from "src/views/common/CommonSearch";

const RoleList = () => {
  const { authenticated } = Auth();
  const [usersData, setuserData] = useState([]); // List data manage
  const [pageCount, setPageCount] = useState(0); // List Data pagging manage
  const [loading, setloading] = useState(false); // page loading
  const [pageLimit, setpageLimit] = useState(0); // pageing index manage
  const [itemPerPage, setItemPerPage] = useState(10); // Record Show Each Page
  const [disabledprev, setdisabledprev] = useState(false); //Pagging Prev. Button disabled manage;
  const [disablednext, setdisablednext] = useState(false); //Pagging Next Button disabled manage;
  const [isSearch, setIsSearch] = useState(false); // Search Button Effect Manage
  const [isClear, setIsClear] = useState(false); // Clear Button Effect Manage
  // const [textField, settextField] = useState("tenderNo"); // table header Default Selected Column
  // const [order, setorder] = useState("asc"); // table header Default Selected Column order Set
  // const [orderClick, setOrderClick] = useState(true); // table header orderClick Column manage

  // // Your default search model
  const SearchFilterModel = {
    roleName: "",
  };

  const [search, setSearch] = useState(SearchFilterModel); // Search Manage

  useEffect(() => {
    setloading(true);
    resetPageLimit();
    getPageCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  useEffect(() => {
    if (isSearch === false) {
      getRoleRightList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, pageLimit, itemPerPage]);

  useEffect(() => {
    if (isSearch) {
      getPageCount();
      getRoleRightList();
      setIsClear(false);
      setIsSearch(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearch, itemPerPage]);

  //Pagging Disabled /Enable manage
  const paggingDisabled = (isNext = true, isPrev = true) => {
    setdisablednext(isNext);
    setdisabledprev(isPrev);
  };
  //Pagging manage
  const paggingManage = (totalRecord, isRecordGet = true) => {
    setPageCount(parseInt(totalRecord) || 0);
    paggingDisabled(
      pageLimit >= parseInt(totalRecord) - parseInt(itemPerPage),
      pageLimit === 0
    );
  };

  const getPageCount = async () => {
    if (authenticated) {
      await apiCallSPGet(`RoleMaster/List/count`).then((res) => {
        if (res.success) paggingManage(parseInt(res.totalRecord) || 0);
      });
    }
  };
  const getRoleRightList = async () => {
    if (authenticated) {
      paggingDisabled();
      setloading(true);

      const searchrolename =
        search.roleName !== "" || search.roleName !== undefined
          ? "&roleName=" + search.roleName
          : "";
      await apiCallSPGet(
        `RoleMaster/List?start=${pageLimit}&length=${Number(
          itemPerPage
        )}${searchrolename}`
      )
        .then((res) => {
          if (res.success) {
            setuserData(res.data);
            if (pageLimit > -1 && pageCount > 0) {
              paggingManage(pageCount);
            }
          }
          setloading(false);
        })
        .finally();
    }
  };

  const resetPageLimit = (pageLimit) => {
    setpageLimit(pageLimit || 0);
  };

  // Pagging Prev. Button Click Event
  const prevButton = () => {
    let pageLimitSet = parseInt(pageLimit) - parseInt(itemPerPage);
    pageLimitSet = pageLimitSet < 0 ? 0 : pageLimitSet;
    resetPageLimit(pageLimitSet);
  };
  // Pagging Next Button Click Event
  const nextButton = () => {
    let pageLimitSet = parseInt(pageLimit) + parseInt(itemPerPage);
    pageLimitSet =
      pageLimitSet >= parseInt(pageCount) ? parseInt(pageCount) : pageLimitSet;
    resetPageLimit(pageLimitSet);
  };
  let scopedSlotsList = {
    roleIsActive: (item, index) => {
      return (
        <td className="py-2">
          <span>
            {item.isActive === true ? (
              <CBadge color="success" className={"badgeFont100"}>
                Active
              </CBadge>
            ) : (
              <CBadge color="danger" className={"badgeFont100"}>
                InActive
              </CBadge>
            )}
          </span>
        </td>
      );
    },
  };
  let fields = [
    {
      key: "srNo",
      _style: { width: "5%" },
      label: "S.N.",
    },
    {
      key: "roleName",
      _style: { width: "15%" },
      label: "Role Name",
    },
    {
      key: "insertdateformat",
      _style: { width: "15%" },
      label: "Date",
    },
    {
      key: "roleIsActive",
      _style: { width: "15%" },
      label: "Status",
    },
    {
      key: "ConditionalBtn",
      _style: { width: "15%" },
      label: "Edit",
    },
  ];

  // Search Model Value Update Manage
  const updateSearch = (e, name = "", value = "") => {
    updateSearchStatus(setSearch, search, e, name, value);
  };
  // item per page  onChanage Event
  const onChangePage = (ev) => {
    ev.preventDefault();
    setpageLimit(0);
    setItemPerPage(ev.target.value);
    setIsSearch(true);
    paggingManage(pageCount);
  };

  // Search Button Click Event
  const searchButton = (ev) => {
    ev.preventDefault();
    resetPageLimit();
    setIsSearch(true);
  };

  //Clear Button Click Event
  const clearSearch = (ev) => {
    ev.preventDefault();
    resetPageLimit();
    setIsClear(true);
    setIsSearch(true);
    setSearch({ ...search, ...SearchFilterModel });
    setuserData([]);
  };

  const searchControl = (
    <>
      <SCInput
        label={"Role Name :"}
        name={"roleName"}
        value={search.roleName}
        onChange={updateSearch}
      />
    </>
  );
  let additional = (
    <CommonSearchExtra
      isDisabledSearchClear={loading}
      extraControl={searchControl}
      isClear={isClear}
      search={search}
      updateSearch={updateSearch}
      searchButton={searchButton}
      clearSearchButton={clearSearch}
      itemPerPage={itemPerPage}
      onChangePage={onChangePage}
      extraSearchControl={<SCAddButton tourl={"/master/role/add"} />}
    />
  );

  return (
    <CommonList
      items={usersData}
      fields={fields}
      listName="Role Master - Role Rights"
      loading={loading}
      prev={prevButton}
      next={nextButton}
      disabledprev={disabledprev}
      disablednext={disablednext}
      additional={additional}
      path={`/master/role/`}
      tabBtn="Edit"
      id="roleMasterId"
      scopedSlots={scopedSlotsList}
    />
  );
};
export default RoleList;
